import { BoolNumber, FALSE, TRUE } from 'base/utils/soccerHelpers';
import { LineNumbers } from 'components/play/Types/Types';

export function mapSessionLinesIntoBets(sessionLines: LineNumbers[]): BoolNumber[][][] {
    return sessionLines.map((sessionLine) => {
        return sessionLine.map((numbers) => {
            return numbers.map((number) => (number === 1 ? TRUE : FALSE));
        });
    });
}

export function mapBetMatchLinesIntoLines(lines: BoolNumber[][][]): LineNumbers[] {
    return lines.map((line) => {
        return line.map((bets) => {
            return bets.map((bet) => (bet === TRUE ? 1 : 0));
        });
    });
}
